<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeTourneeModele.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="checkPermissions(permTourneeModele.maj) ?
                       $router.push({name: 'm.logistique.tournee_modele-ajout'}) : showPopUp()"
                      :class="{ 'button-access-no-permission' :
                      !checkPermissions(permTourneeModele.maj) }">
                {{ $t('listeTourneeModele.newListe')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <form @submit.prevent="recherche()" class="column is-12">
            <b-input :placeholder="$t('listeTourneeModele.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class="column is-narrow">
            <button class="button" @click="changeValueShowFiltreAndLockMenu">
              <b-icon icon="filter-variant" size="is-small" type="is-default"/>
              <span class="is-size-7">
              {{$t('general.button.filtre')}}
              <label
                class="has-text-weight-bold"
                :class="nombreCritere > 0 ? '' : 'is-invisible'">
                ({{ nombreCritere }})
              </label>
            </span>
            </button>
            <span
              class="info-circle-right is-pulled-right is-cursor-pointer"
              @click="reinitialiserFiltre()">
            <b-icon icon="close-circle" type="is-danger"/>
          </span>
          </div>
        </div>
      </div>
      <div class="columns level-right">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permTourneeModele.exporter"
            :query="exportExcelQuery"/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <a ref="lienDownload"></a>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="libelle" slot-scope="props">
        <router-link :class="{'text-access-no-permission':
                     !checkPermissions(permTourneeModele.lecture)}"
                     :to="{ name: 'c.logistique.tournee_modele', params: {id: props.row.id}}">
          <a class='lien'>{{props.row.libelle}}</a>
        </router-link>
      </div>
      <div slot="jourDepart" slot-scope="props">
        {{ getJourDeLaSemaine(props.row.jourDepart) }}
      </div>
      <div slot="afficheur" slot-scope="props">
        {{ props.row.afficheur ? props.row.afficheur.nomCommercial : '' }}
      </div>
      <div slot="nbFaces" slot-scope="props">
        <div class="is-pulled-right">
        {{ props.row.tourneeLignes.length }}
        </div>
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId) }}
      </div>
      <div slot="edit" slot-scope="props">
        <router-link :to="{name: 'm.logistique.tournee_modele-edit',
            params: {id: props.row.id }}"
            :class="{'disabled': !props.row.actif}">
          <b-icon icon="pencil-box-outline"
                  :type="{ 'is-success' : props.row.actif }"
                  :class="{ 'text-access-no-permission' :
                      !checkPermissions(permTourneeModele.maj) }"></b-icon>
        </router-link>
      </div>
      <div slot="archive" slot-scope="props" class="has-text-centered">
        <a @click="checkPermissions(permTourneeModele.supprimer) ?
          launchPopUpArchivage(props.row) : showPopUp()">
          <b-icon type="is-default"
                  :icon="props.row.actif ? 'archive' : 'archive-arrow-up'"
                  :class="{
              'text-access-no-permission' : !checkPermissions(permTourneeModele.supprimer)
              }"
          ></b-icon>
        </a>
      </div>
      <div slot="delete" slot-scope="props">
        <div @click="checkPermissions(permTourneeModele.supprimer) ?
            launchPopUpSuppression(props.row.id) : showPopUp()"
             class="is-cursor-pointer">
          <b-icon type="is-danger" icon="delete-forever" :class="{ 'text-access-no-permission' :
                      !checkPermissions(permTourneeModele.supprimer) }"
          ></b-icon>
        </div>
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-show="showFiltre === true">
        <filtre-tournee-modele ref="filtreListeTourne"
                               @toggleFiltre="changeValueShowFiltreAndLockMenu"
                               @recherche="makeRechercheFilter">
        </filtre-tournee-modele>
      </div>
    </transition>
    <b-modal v-model="openPopUpArchivage"
             has-modal-card
             class="modal" @close="tourneeModeleToArchive = null">
      <pop-up-prevention
        v-if="tourneeModeleToArchive"
        @no="openPopUpArchivage = false"
        @yes="archiverTourneeModele"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        :mess-header="$t(('listeTourneeModele.archivageDesarchiver.'
        + (tourneeModeleToArchive.actif ? 'archivage' : 'desarchivage')))">
      </pop-up-prevention>
    </b-modal>
    <b-modal v-model="openPopUpSuppression" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="this.$t('listeTourneeModele.popUpSuppression.title')"
        :cancel="this.$t('general.non')"
        :validate="this.$t('general.oui')"
        :messagesPopup="messagesErreurPopUp"
        :isErrorPopup.sync="errorPopUp"
        @no="openPopUpSuppression = false"
        @yes="deleteTourneeModele"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
  EXPORT_EXCEL_LISTE_AFFICHAGE,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { LISTE_INDEX_JOURS } from '@/configuration/datePickerConf';
import ucFirst from '@/services/general/ucFirst';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import { TOURNEE_MODELE } from '@/configuration/logistique/permissionsLogistiqueConf';
import filtreTourneeModele from '@/components/logistique/tourneeModele/filtreTourneeModele';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import PopUpPrevention from '@/components/general/popUpPrevention';
import messageSucces from '@/services/general/messageSucces';
import validationTourneeModele from '@/services/logistique/tourneeModele/validation';
import { archiver, deleteTournee } from '@/api/logistique/tourneeModele/index';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_TOURNEE_MODELE } from '@/configuration/general/referenceTableConf';

const tourneeModele = createNamespacedHelpers('tourneeModele');
const Societe = createNamespacedHelpers('societe');
const permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      unsubscribeValue: null,
      permTourneeModele: TOURNEE_MODELE,
      showFiltre: false,
      tourneeModeleToArchive: null,
      openPopUpArchivage: false,
      errorPopUp: false,
      messagesErreurPopUp: [],
      openPopUpSuppression: false,
      idToDelete: null,
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_TOURNEE_MODELE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    filtreTourneeModele,
    PopUpPrevention,
    parametrageTable,
    exportExcelButton,
  },
  methods: {
    ...tourneeModele.mapActions({
      actionLoadTourneeModele: 'loadTourneeModele',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeTourne.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs.tableTourneeModele.refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    getAgenceLibelle(agenceId) {
      let libelleAgence = '';
      this.societesInformations.forEach((societe) => {
        societe.agences.forEach((agence) => {
          if (agence.id === agenceId) libelleAgence = agence.libelle;
        });
      });
      return libelleAgence;
    },
    getJourDeLaSemaine(number) {
      return ucFirst(LISTE_INDEX_JOURS.find((jour) => { return jour.number === number; }).libelle);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeTourne.initializeFiltre();
      this.$refs.filtreListeTourne.viderCritere();
      this.$refs.filtreListeTourne.appliquerCritere();
      this.filtreVisible = false;
    },
    launchPopUpArchivage(tourneeModele) {
      this.tourneeModeleToArchive = tourneeModele;
      this.openPopUpArchivage = true;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    launchPopUpSuppression(id) {
      this.idToDelete = id;
      this.openPopUpSuppression = true;
      this.errorPopUp = false;
      this.messagesErreurPopUp = [];
    },
    async archiverTourneeModele() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await archiver(this.tourneeModeleToArchive.id, this.tourneeModeleToArchive.actif);
        messageSucces(this.$i18n.t('listeTourneeModele.messages.success.' + (this.tourneeModeleToArchive.actif ? 'archivage' : 'desarchivage')));
        this.openPopUpArchivage = false;
        this.tourneeModeleToArchive = null;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationTourneeModele(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    async deleteTourneeModele() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorPopUp = false;
        this.messagesErreurPopUp = [];
        await deleteTournee(this.idToDelete);
        messageSucces(this.$t('listeTourneeModele.messages.success.deleteTournee'));
        this.openPopUpSuppression = false;
        this.idToDelete = null;
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response && e.response.data.error) {
          validationTourneeModele(e.response, this.messagesErreurPopUp);
          this.errorPopUp = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  computed: {
    ...tourneeModele.mapGetters({
      items: 'items',
      totalCount: 'total',
      critereRecherche: 'critereRecherche',
      lastPayload: 'lastPayload',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      societesInformations: 'societesInformations',
      lockMenu: 'lockMenu',
      agenceActive: 'agenceActive',
    }),
    nombreCritere() {
      const banCritere = ['auto', 'societeId', 'actif'];
      if (this.societeActive.agences.length === 1) banCritere.push('agencesIds');
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      nbCritere += this.critereRecherche.actif != null ? 1 : 0;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeTourneeModele.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeTourneeModele.breadcrumb.listeAffichage'), route: '', isActive: true },
      ];
      return output;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeTourneeModele.tableau.nomListeAffichage'),
          afficheur: this.$t('listeTourneeModele.tableau.afficheurAffecte'),
          jourDepart: this.$t('listeTourneeModele.tableau.joursDepart'),
          nbFaces: this.$t('listeTourneeModele.tableau.nbFaces'),
          agence: this.$t('listeTourneeModele.tableau.agence'),
          edit: '',
          archive: '',
          delete: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          let listeAgenceId = [];
          if (this.agenceActiveId.length > 1) {
            listeAgenceId = this.critereRecherche.agenceIds.filter(
              (agenceId) => this.agenceActiveId.find((id) => agenceId === id));
          } else {
            this.critereRecherche.agenceIds = [];
            listeAgenceId = this.agenceActiveId;
          }
          data.query = {
            auto: this.critereRecherche.auto,
            societeId: this.societeActiveId,
            agenceIds: listeAgenceId,
            actif: this.critereRecherche.actif,
          };
          if (this.critereRecherche.afficheurs.length > 0) {
            data.query.afficheursId = this.critereRecherche.afficheurs.map((t) => t.id);
          }
          return this.actionLoadTourneeModele(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        columnsClasses: {
          edit: 'colonneSelected',
          delete: 'colonneSelected',
          archive: 'colonneSelected',
        },
        sortable: ['libelle', 'afficheur', 'jourDepart', 'nbFaces'],
      };
    },
    columns() {
      const columns = ['libelle', 'afficheur', 'jourDepart', 'nbFaces', 'edit', 'archive', 'delete'];
      if (this.societeActive.agences.length > 1) {
        columns.splice(columns.findIndex((column) => column === 'edit'), 0, 'agence');
      }
      return columns;
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_LISTE_AFFICHAGE,
        typeExport: '',
        filtres: generalTransformer(this.lastPayload),
      };
    },
    agenceActiveId() {
      return this.agenceActive.map((agence) => agence.agenceId);
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageLogistique.tourneeModele.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
